import { useState } from 'react'
import styled from 'styled-components'

interface IProps {
  Icon: JSX.Element
  title: string
  message: string
  id: string
  eventType?: boolean
  collapseLongMessages?: boolean
}

export const CallChatMessage = ({ Icon, message, title, id, eventType, collapseLongMessages = false }: IProps) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const shouldCollapse = collapseLongMessages && message.length > 320
  const displayMessage = shouldCollapse && !isExpanded ? `${message.slice(0, 320).trim()}...` : message

  return (
    <Div id={id}>
      {eventType ? (
        <div className="take-over">{message}</div>
      ) : (
        <div className="chat-message-flex">
          <div className="chat-agent-icon">{Icon}</div>
          <div className="chat-message-container">
            {title && <span className="chat-message-title">{title}</span>}
            <span className="chat-message">{displayMessage}</span>
            {shouldCollapse && (
              <button className="read-more-button" type="button" onClick={() => setIsExpanded((prev) => !prev)}>
                {isExpanded ? 'Show less' : 'Read more'}
              </button>
            )}
          </div>
        </div>
      )}
    </Div>
  )
}

const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-width: 0;

  .take-over {
    display: grid;
    gird-auto-flow: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: ${({ theme }) => theme.util.pixelToRem(5)} 0;
    border-radius: 5px;
    border: solid 2px #ffd870;
    background-color: #fff2cf;
    font-family: ${({ theme }) => theme.fontFamily.milliard};
    padding: ${({ theme }) => theme.util.pixelToRem(10)} 0px ${({ theme }) => theme.typography.s.normal};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    text-align: center;
    color: ${({ theme }) => theme.colors.primary.darker};
    width: 100%;
    

  }

  .chat-message-flex {
    display: flex;
    width: 100%;
    min-width: 0;
    margin-bottom: 1rem;
    justify-content: space-between;
    gap: 0.75rem;
  }

  .chat-agent-icon {
    align-items: center;

    svg {
      width: 2.125rem;
      height: 2.125rem;
    }
  }

  .chat-message-container {
    display: flex;
    flex-direction: column;
    min-width: 0;
    flex: 1;

    .chat-message-title {
      ${({ theme }) => theme.typography.s.normal};
      color: ${({ theme }) => theme.colors.primary.darker};
      font-weight: ${({ theme }) => theme.fontWeight.medium};
      overflow-wrap: anywhere;
    }

    .chat-message {
      color: ${({ theme }) => theme.colors.grey.dark};
      ${({ theme }) => theme.typography.m.normal};
      font-weight: ${({ theme }) => theme.fontWeight.medium};
      white-space: pre-wrap;
      overflow-wrap: anywhere;
      word-break: break-word;
    }

    .read-more-button {
      align-self: flex-start;
      border: 0;
      background: transparent;
      padding: 0.25rem 0 0;
      color: ${({ theme }) => theme.colors.info.neutral};
      ${({ theme }) => theme.typography.s.medium};
      cursor: pointer;
    }
  }
`
